module.exports = __webpack_public_path__ + "img/login.cf41b17c.jpg";